import React from "react";
import { BaseText } from "web/react/emo/shared/components/base-text/base-text";
import * as styles from "./price.css";

const FontsMap = {
    xs: "body-s-bold",
    sm: "body-bold",
    md: "subhead",
    xm: "title-3",
    lg: "title-2",
} as const;

export interface PriceProps {
    fullPrice: string | number;
    inStock: boolean;
    dataTestId?: string;
    salePrice?: string | number | null;
    size?: keyof typeof FontsMap;
}

export function Price({
    fullPrice,
    salePrice,
    inStock,
    dataTestId,
    size = "sm",
}: PriceProps): JSX.Element {
    const textStyle = FontsMap[size];

    const hideOriginalPrice = !inStock && salePrice;

    return (
        <div data-testid={dataTestId || "product-price"} className={styles.priceContainer}>
            {!hideOriginalPrice && (
                <BaseText
                    textStyle={textStyle}
                    strikeThrough={salePrice || !inStock ? true : false}
                >
                    {fullPrice}
                </BaseText>
            )}
            {salePrice && (
                <BaseText
                    textStyle={textStyle}
                    strikeThrough={!inStock ? true : false}
                    color="highlightBrand"
                >
                    {salePrice}
                </BaseText>
            )}
        </div>
    );
}
